// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel[data-v-cb3d6a20] {\n  margin-bottom: 12px;\n}", ""]);
// Exports
module.exports = exports;
